const initialState = {
  appointments: [],
  payments: [],
  appointment: null,
  total: 0,
  loading: false,
  error: null,
};

export const homeVisitReducer = (state = initialState, action) => {
  switch (action.type) {
    // Appointment List
    case "USER_APPOINTMENT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "USER_APPOINTMENT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        appointments: action.payload.data || [],
        total: action.payload.total || 0,
        error: null,
      };

    case "USER_APPOINTMENT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Payment List  
    case "USER_APPOINTMENT_PAYMENT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "USER_APPOINTMENT_PAYMENT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        payments: action.payload.data || [],
        error: null,
      };

    case "USER_APPOINTMENT_PAYMENT_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Appointment View
    case "USER_APPOINTMENT_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "USER_APPOINTMENT_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        appointment: action.payload.data || null,
        error: null,
      };

    case "USER_APPOINTMENT_VIEW_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        appointment: null,
      };

    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
